import React, { forwardRef, type ReactNode } from "react";

import { DropdownMenuLabel } from "src/primitives/DropdownMenu";

interface MenuLabelProps extends React.ComponentProps<"div"> {
  children?: ReactNode;
  className?: string;
}

const Label = forwardRef<HTMLDivElement, MenuLabelProps>(
  ({ children, className, ...otherProps }, ref) => (
    <DropdownMenuLabel ref={ref} className={className} {...otherProps}>
      {children}
    </DropdownMenuLabel>
  )
);
Label.displayName = "Dropdown.Label";

export { Label };
